import { QueryClient } from '@tanstack/react-query';
import { normalizeApiError } from '@/services/httpError';

/**
 * Application-wide server-state cache.
 * Defaults favor correctness over aggressive refetching.
 */
export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 60_000,
			gcTime: 5 * 60_000,
			retry: (failureCount, error) => {
				const status = normalizeApiError(error).status;
				// Do not retry client/authorization errors.
				if (status && status >= 400 && status < 500) return false;
				return failureCount < 2;
			},
			refetchOnWindowFocus: false,
		},
		mutations: {
			retry: false,
		},
	},
});
